// Rack -> bin enumeration shared by cycle-count location selection and bin-label
// printing. Bin identifiers must match pallet_items.warehouse_location byte-for-byte,
// so both callers unroll racks identically here rather than each rolling their own.

export function rackBinLabel(rack) {
    return rack?.customName || `${rack?.isPool ? 'Pool' : 'Rack'} ${rack?.rackIdentifier}`;
}

// Returns one entry per bin: { label, rackIdentifier, isPool, row, column, depth }.
// Pools collapse to a single entry (row/column/depth = 1) keyed by the pool label.
export function enumerateWarehouseBins(warehouseRacks = []) {
    if (!Array.isArray(warehouseRacks)) return [];

    const bins = [];
    warehouseRacks.forEach((rack) => {
        const label = rackBinLabel(rack);
        if (rack?.isPool) {
            bins.push({ label, rackIdentifier: rack?.rackIdentifier, isPool: true, row: 1, column: 1, depth: 1 });
            return;
        }
        for (let r = 1; r <= Number(rack?.rows || 0); r++) {
            for (let c = 1; c <= Number(rack?.columns || 0); c++) {
                for (let d = 1; d <= Number(rack?.rackDepth || 0); d++) {
                    bins.push({
                        label: `${label}-${r}-${c}-${d}`,
                        rackIdentifier: rack?.rackIdentifier,
                        isPool: false,
                        row: r,
                        column: c,
                        depth: d,
                    });
                }
            }
        }
    });
    return bins;
}
